import {useAppSelector} from "@Hooks/selector/useAppSelector";
import getPassengerToAutoAssignSelectedPassengerClass
    from "@CheckOrder/features/classPicker/functions/getPassengerToAutoAssignSelectedPassengerClass";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

export default function useGetPriceForPassengerClass(
    passengerClass: AvailablePassengerClassType,
    passengerId: number,
    isReturn?: boolean
) {
    const {
        ticket: {singleSelectedPassengerClasses, returnSelectedPassengerClasses},
        passengers,
    } = useAppSelector((state) => (state.checkOrder))

    const selectedPassengerClasses = isReturn ? returnSelectedPassengerClasses : singleSelectedPassengerClasses

    const getPrice = () => {
        const passengersInThisTypeOfClass = selectedPassengerClasses.classToPassengersMap[passengerClass.id]

        if (passengersInThisTypeOfClass) {
            const passengerIdGroupIndex = selectedPassengerClasses.classToPassengersMap[passengerClass.id].findIndex((passengersIdsGroup) => (
                passengersIdsGroup.includes(passengerId)
            ))

            if (passengerIdGroupIndex !== -1) {
                return passengerClass.prices[selectedPassengerClasses.classToPassengersMap[passengerClass.id][passengerIdGroupIndex].length]
            }
        }

        const possiblyAutoAssignedPassengers = getPassengerToAutoAssignSelectedPassengerClass(
            selectedPassengerClasses,
            passengers,
            passengerId,
            passengerClass
        )

        return passengerClass.prices[possiblyAutoAssignedPassengers.length]
    }

    return {
        getPrice,
    }
}